export default {
    // TMSCODEMAST: "/tms/codeMast",
    TMSGETWAYORDERS: "/tms/getWayOrders",
    TMSGETROUTES: "/tms/getRoutes",
    TMSGETROUTEWAYS: "/tms/getRouteWays",
    TMSDELETEROUTEHEADER:"/tms/deleteRouteHeader",
    TMSSAVEROUTEHEADER: "/tms/saveRouteHeader",
    TMSGETROUTE: "/tms/getRoute",
    TMSDELETEROUTEWAY: "/tms/deleteRouteWay",
    TMSGETTMSDOHEADERS: "/tms/getTmsDoHeaders",
    TMSFINDDELIVERIES: "/tms/findDeliveries",
    TMSSAVEROUTEWAY: "/tms/saveRouteWay",
    TMSGETROUTEWAY:"/tms/getRouteWay",
    TMSDELETETMSDOHEADER:'/tms/deleteTmsDoHeader',
    TMSSAVETMSDOHEADER: "/tms/saveTmsDoHeader",
    TMSSORTWAY: "/tms/sortWay",
    INVWINEDROPDOWN: "/inv/wine/dropdown",
    TMSSPLITROUTE: "/tms/splitRoute",
    TMSGETTMSDOHEADERBYID: "/tms/getTmsDoHeaderById",
    TMSFINDTMSDROPDOWNINFO: "/tms/findTmsDropdownInfo",
    TMSSAVETMSROUTEDETAIL: "/tms/saveTmsRouteDetail",
    TMSDELETEROUTEDETAIL:"/tms/deleteTmsRouteDetails",
    TMSIMPORTDOHEADER:"/tms/importTmsDoHeaders",
    TMSDRAGORDERSTOROUTEHEADER:"/tms/dragOrdersToRouteHeader",
    TMSMERGEROUTE: "/tms/mergeRoute",
    TMSCOMFIRMROUTE: "/tms/comfirmRoute",
    TMSUNCOMFIRMROUTE: "/tms/uncomfirmRoute",
    TMSGETVEHICLEDROPDONINFO: "/tms/getVehicleDropdownInfo",
    TMSGETDRIVERDROPDOENINFO:"/tms/getDriverDropdownInfo"
}